import React from 'react';

export const Loader = ({ className = '', text = 'Loading...' }) => {
  return (
    <div className={`flex flex-col items-center justify-center space-y-2 ${className}`}>
      <div
        className="w-12 h-12 border-4 border-current border-t-transparent rounded-full animate-spin"
      />
      <span className="text-gray-500 text-sm tracking-wide">{text}</span>
    </div>
  );
};
